import messageStyles from "./message.module.css";
import { AppImage } from "../appMedia";
import { getTimeFromTimestamp } from "../../utils/utils";
import { IChatMessage, IConversation } from "../../types/types";
import { useAppSelector } from "../../services/hooks";
import { userSelector } from "../../services/selectors/user.selectors";
import { noDataLabel } from "../../utils/constants";
import avatarPlaceholder from "../../images/avatar_placeholder.svg";

function MessageChat({
  message,
  isOwnMessage,
  therapist,
}: {
  message: IChatMessage;
  isOwnMessage: boolean;
  therapist: IConversation | undefined;
}) {
  const messageClassname = isOwnMessage
    ? messageStyles.ownMessage
    : messageStyles.message;
  const containerClassname = isOwnMessage
    ? `${messageStyles.messageContainer} ${messageStyles.ownMessageContainer}`
    : messageStyles.messageContainer;

  const user = useAppSelector(userSelector);

  const avatar = isOwnMessage ? user.avatar : therapist?.avatar;
  const alt = isOwnMessage ? user.fullName : noDataLabel;

  return (
    <>
      <div className={containerClassname}>
        <div className={messageClassname}>
          <p className={messageStyles.text} data-testid={isOwnMessage ? "client-message-text" : "therapist-message-text"}>
            {message.content.split("\n").map((part, index) => (
              <span key={index} className={messageStyles.textPart}>
                {part}
              </span>
            ))}
          </p>
          <p
            className={`${messageStyles.time} ${
              isOwnMessage && messageStyles.time_ownMessage
            }`}
            data-testid={isOwnMessage ? "client-message-time" : "therapist-message-time"}
          >
            {message.sentDate ? getTimeFromTimestamp(message.sentDate) : ""}
          </p>
        </div>
        <AppImage
          src={avatar || avatarPlaceholder}
          alt={alt}
          className={messageStyles.avatar}
        />
      </div>
    </>
  );
}

export default MessageChat;